import React, { useEffect } from 'react';
import { useStateMachineInput } from '@rive-app/react-canvas-lite';
import useRive from 'ui-lib/hooks/useRive';

import computerAnimation from '../../media/animated-icons/server-error.riv';
import useThemeBrightness from '../../hooks/useThemeBrightness';
import { THEME_TYPE } from '../../consts';

const AnimationImage = () => {
  const themeBrightness = useThemeBrightness();
  const { rive, RiveComponent, failed } = useRive({
    src: computerAnimation,
    autoplay: true,
    stateMachines: 'State Machine',
  });

  const darkThemeInput = useStateMachineInput(rive, 'State Machine', 'DarkTheme');

  useEffect(() => {
    if (darkThemeInput) {
      darkThemeInput.value = themeBrightness === THEME_TYPE.DARK;
    }
  }, [darkThemeInput, themeBrightness]);

  if (failed) return null;

  return <RiveComponent />;
};

export default AnimationImage;
